import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IRopeTypeSize, IRopeTypeForm } from 'src/models/rope-type.model';
import { useRopeTypeContext } from 'src/contexts/rope-type.context';
import Lang from 'src/libraries/language';
import { getRopeTypeStatus } from 'src/selectors/rope-type.selector';
import { actionTypes } from 'src/ducks/rope-type.duck';
import RopeSizeConductorForm from '../rope-size-conductor-form/rope-size-conductor-form.component';
import style from '../rope-size-conductor-list/rope-size-conductor-list.module.scss';

type IProp = {
  data: IRopeTypeSize;
};

const RopeSizeConductorEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useRopeTypeContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IRopeTypeSize> = {
    ropeType: '',
    ropeId: 0,
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getRopeTypeStatus(state, actionTypes.ROPE_TYPE_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IRopeTypeForm = {
        ropeType: value.ropeType,
      };
      const response = await actions.updatePUT(value.ropeId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_ROPE_EDIT_SUCCESS,
            formData.ropeType ? formData.ropeType : value.ropeType
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_EDIT_ROPE_CONDUCTOR}
      content={
        <div className={style.content}>
          <RopeSizeConductorForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default RopeSizeConductorEdit;
